export default "__VITE_ASSET__56705700__"